define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/html",
	"csi/table/matrix/Path",
], function(declare, _, csi, html, PathMatrix) {

	// Special use cases to handle with BOM compare:
	// 1. New rows should not include old sizes
	// 2. Old rows should not include new sizes
	// 3. If Only for Sizes is specified, then need to also include sizes that were previously in Only for Sizes

	return declare(PathMatrix, {
		restrictQuery: true,

		/**
		 * @override
		 * Return key indicating size url(s) for column
		 */
		getCompareKeyForMergedCells(ctx, spec, index) {
			const key = spec.key.toString();
			const sizeUrl = ctx.getNodeURL();
			return `Rows_${key}_${sizeUrl}`;
		},

		/**
		 * @override
		 * If matrix is in view, then add necessary dependency paths to PartMaterial query level(s) (could be in multi-level view)
		 */
		onPathSpecParams(ctx, params, columnIndex) {
			const {view} = ctx;
			const ql = view.getMainQueryLevel();
			const paths = [
				"Child:CommonSize;CommonSizeSpec;PartMaterialQuantities",
				"Child:PartMaterialSizes/Child:PMSSize",
				"Child:PartMaterialSizeSpecs/Child:PMSSizeSpec",
			];

			ql.addDependencyPaths(paths);

			if (ql.childLevel) {
				ql.childLevel.addDependencyPaths(paths);
			}
		},

		/**
		 * @override
		 * Replace headings in column matrix with headings in respective solo matrix
		 */
		onPathSubSpecParams(ctx, params, columnIndex) {
			const h = ctx.view.getSizeColumnHeading(params.heading);
			if (h) {
				params.heading = h;
			}
		},

		/**
		 * @override
		 * Return all sizes that apply for current query result unless OKVariationByBOMSize is un-checked
		 */
		_getSpecNodes(ctx, spec, nodes) {
			const pm = ctx.getNodeOfType("PartMaterial");
			if (!pm || !pm.OKVariationByBOMSize) {
				return [];
			} else {
				const sizeSet = ctx.view.getSizeSetForQueryResultInContext(ctx);
				return sizeSet ? sizeSet.getAllSizes() : [];
			}
		},

		/**
		 * @override
		 * Add cell edit behavior
		 */
		_renderCellContent(ctx, h, td, columnSpec, index) {
			const {queryResult, view} = ctx;
			const columnMap = view.getSizeColumnMap(ctx, queryResult, h.m_id, !queryResult.level.bMain);
			const sizeUrl = ctx.getNodeURL();
			const isOld = view.isOldSize(sizeUrl);

			if (columnMap) {
				if (isOld) {
					// if old, then nothing to display - still render though to get appropriate CSS classes for heading
					ctx.setNode(null);
				} else {
					// map ProductSize url to size variation url
					ctx.setNodeURL(columnMap[sizeUrl]);
				}
			}

			this.inherited(arguments);

			if (columnMap) {
				const node = ctx.getNode();
				if (node) {
					view.postRenderSizeVariationCell(ctx, td, ctx.getNodeType());
				} else {
					// cell is N/A
					td.classList.add(html.CSS_NOT_APPLICABLE);
				}
			}

			// add styling if old size or not in OnlyForSizes; add at the end or else it will be overridden by normal renderer
			if (isOld) {
				view.compareData.addOldStyling(td);
			}
		}
	});
});